<script>
import FormModalMixin from '../../../../../share/modal/FormModalMixin'
import FormModal from '../form/NewBank'
import api from '../../../../../../api'

export default {
  components: {
    FormModal
  },
  mixins: [
    FormModalMixin
  ],
  props: {
    mode: { type: String, required: true },
    service: { type: String, required: true }
  },
  data () {
    return {
      events: {
        newBankModal: 'core:bank:newBankModal'
      },
      title: 'Dodanie banku',
      method: { new: 'post' },
      action: { new: '/bank' }
    }
  },
  methods: {
    submitForm () {
      api.request(this.service, this.method[this.mode], this.action[this.mode], this.createDataToSend())
        .then(() => {
          this.toggleLoading()

          this.$events.$emit('reloadGrid')
          this.$emit('close')
          this.$notify({
            type: 'success',
            text: 'Dodano bank'
          })
        })
        .catch((error) => {
          this.toggleLoading()
          this.errorNotify(error, 'error', 'Wystąpił błąd', 'Nie można dodać banku.')
        })
    },
    createDataToSend () {
      return {
        label: this.model.label,
        voivodeship: this.model.voivodeship,
        city: this.model.city,
        postcode: this.model.postcode,
        street: this.model.street,
        email: this.model.email,
        phone: this.model.phone
      }
    }
  }
}
</script>
